<div [ngClass]="isTitle ? '' : 'py-1'" class="text-xs md:">
  <span *ngIf="isTitle">Tình trạng</span>
  <span [ngClass]="isTitle ? 'ml-3.5' : ''"> {{ status === 'completed' ? 'Hoàn thành' : status === 'dropped' ? 'Ngưng viết' : 'Đang viết' }} </span>
</div>